/**
 * Cookie helper utility for user app
 * Reads authentication token from cookie set by client app
 */

const COOKIE_NAME = 'auth_token';

/**
 * Get a cookie value by name
 * @param name - The name of the cookie to retrieve
 * @returns The cookie value or null if not found
 */
export const getCookie = (name: string): string | null => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }

  return null;
};

/**
 * Get authentication token from cookie
 * Falls back to localStorage if cookie is not available
 * @returns The authentication token or null
 */
export const getAuthToken = (): string | null => {
  // First try to get from cookie (set by client app for cross-subdomain access)
  const cookieToken = getCookie(COOKIE_NAME);
  if (cookieToken) {
    return cookieToken;
  }

  // Fallback to localStorage for backward compatibility
  return localStorage.getItem('token');
};

/**
 * Remove authentication token from localStorage
 * Note: Cookie removal is handled by client app
 */
export const removeAuthToken = (): void => {
  localStorage.removeItem('token');
};
